import type { GetOrdersQueryVariables } from "~/gql/queries/order.generated";

import { OrderStatus, OrderType, SortEnumType } from "~/gql/graphqlBase.generated";

const quoteTourOrdersQuery = (email: string): GetOrdersQueryVariables => ({
	first: 1,
	order: [{ initializedDate: SortEnumType.Desc }],
	where: {
		orderStatus: { eq: OrderStatus.Open },
		orderType: { neq: OrderType.Credit },
		salesPerson: { contains: email }
	}
});
export default quoteTourOrdersQuery;
